import { Fragment } from 'react';
import {
    Datagrid,
    TextField,
    TextInput,
    Filter,
    BulkDeleteButton,
    BulkExportButton,
    BooleanField,
    required,
    SelectInput,
} from 'react-admin';
import { List, ListActions } from '@react-admin/ra-enterprise';
import { CustomBreadcrumb } from './CustomBreadcrumb';
import CustomPagination from './CustomPagination';
import { makeStyles } from '@material-ui/core/styles';
import { EditableDatagrid, RowForm } from '@react-admin/ra-editable-datagrid';
import BestPriceIcon from './BestPriceIcon';
import PaymentMode from './PaymentMode';


function idRoleAllow(resource_name, action_name) {
    let return_value = 'no';
    let login_role = localStorage.getItem('role');
    if (login_role == 'admin') {
        return 'ok';
    }
    let allpermission = JSON.parse(localStorage.getItem("roles"));
    let roledata = [];
    if (login_role == 'accountant') {
        roledata = allpermission.accountant;
    }
    if (login_role == 'auditor') {
        roledata = allpermission.auditor;
    }
    if (login_role == 'editor') {
        roledata = allpermission.editor;
    }
    roledata.map((role_row, index) => {
        if ((role_row.resource == resource_name) && (role_row.action.indexOf(action_name) > -1)) {
            console.log('operation ok');
            return_value = 'ok';
        }
    });
    return return_value;
}
const SellPairBulkActionButtons = ({ basePath }) => (
    <Fragment>
        {(idRoleAllow('markets', 'export') == 'ok') ?
            <BulkExportButton /> : ''}
        {(idRoleAllow('markets', 'delete') == 'ok') ?
            <BulkDeleteButton basePath={basePath} /> : ''}
    </Fragment>
);

const SellPairActions = (props) => (
    <ListActions  {...props} breadcrumb={<CustomBreadcrumb variant="actions" />} exporter={(idRoleAllow('markets', 'export') == 'ok') ? true : false} />
)

const SellPairFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Markets" source="pair" defaultValue="" />
    </Filter>
);

const newStyle = makeStyles({
    tdcolor: { color: '#4f3cc9' }
});

const SellCurrencyForm = props => (
    <RowForm {...props}>
        <TextInput source="pair" label="Markets" validate={required()} style={{ width: '120px !important' }} />
        <TextField source="course_price" autoFocus label="Course price" validate={required()} style={{ width: '120px !important' }} />
        <TextField source="process_fee" label="Process fee" validate={required()} style={{ width: '120px !important' }} />
        <TextInput source="orginal_fee_alter" label="Fees" validate={required()} />
        <TextInput source="bonus_alter" label="Bonus" validate={required()} />
        <TextField source="xml_rate" label="Receivable" validate={required()} />
        {/* <SelectInput source="best_price" choices={bestprice_choices} label="Best price" validate={required()} /> */}
        <SelectInput source="system_process_by" choices={payments_choices} label="Payment mode" validate={required()} />
        <TextInput source="grate_alter" label="Timers" validate={required()} className="timerWidth" />
        <SelectInput source="status" choices={status_choices} label="Status" validate={required()} className="statusWidth" />
    </RowForm>
);

const payments_choices = [
    { id: 'Manual', name: 'Manual' },
    { id: 'Semi-automatic', name: 'Semi-automatic' },
    { id: 'Automatic', name: 'Automatic' }]

// const bestprice_choices = [
//     { id: 'Last price', name: 'Last price' }]

const status_choices = [
    { id: true, name: 'Active' },
    { id: false, name: 'Inactive' }];

const SellPair = (props) => {
    return (
        <List
            {...props}
            sort={{ field: 'pair', order: 'ASC' }}
            hasCreate
            empty={false}
            actions={<SellPairActions />}
            filters={<SellPairFilter />}
            bulkActionButtons={<SellPairBulkActionButtons />}
            pagination={<CustomPagination />}
            title="Sell pair"
            className='exchange_pair'
        >
            <EditableDatagrid
                className="lastOrdersColumn"
                rowClick="edit"
                createForm={<SellCurrencyForm />}
                editForm={<SellCurrencyForm />}
            >
                <TextField source="pair" label="Markets" />
                <TextField source="course_price_alter" label="Course price" />
                <TextField source="process_fee_alter" label="Process fee" />
                <TextField source="orginal_fee" label="Fees" />
                <TextField source="bonus" label="Bonus" />
                <TextField source="xml_rate_alter" label="Receivable" />
                {/* <BestPriceIcon source="best_price" label="Price" /> */}
                <PaymentMode source="system_process_by" label="Mode" />
                <TextField source="grate" label="Timers" />
                <BooleanField source="status" label="Status" />
            </EditableDatagrid>
        </List>
    )
};
export default SellPair;